import { render, staticRenderFns } from "./PlanningCommentsCard.vue?vue&type=template&id=b95d77ba&"
import script from "./PlanningCommentsCard.vue?vue&type=script&lang=js&"
export * from "./PlanningCommentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports